import { computed, onMounted, ref } from "vue";
import { useMapGetter, useStore } from "dashboard/composables/store";
import AiRoutingConfigAPI from "dashboard/api/aiRoutingConfig";
import TasksAPI from "dashboard/api/captain/tasks";

const cleanLabels = labels => {
  return labels
    .toLowerCase()
    .split(",")
    .filter(label => label.trim())
    .map(label => label.trim())
    .filter((label, index, self) => self.indexOf(label) === index);
};

export function useLabelSuggestions() {
  const store = useStore();
  const currentChat = useMapGetter("getSelectedChat");
  const conversationId = computed(() => currentChat.value?.id);
  const aiRoutingLabelSuggestionsEnabled = ref(false);

  const isLabelSuggestionFeatureEnabled = computed(() => true); // [Omnira] Always enabled

  const captainTasksEnabled = computed(() => true);

  const fetchAiRoutingConfig = async () => {
    try {
      const res = await AiRoutingConfigAPI.get();
      const data = res.data || res;
      aiRoutingLabelSuggestionsEnabled.value = !!data.label_suggestions_enabled;
    } catch {
      aiRoutingLabelSuggestionsEnabled.value = false;
    }
  };

  const getLabelSuggestions = async () => {
    if (!conversationId.value) return { matched: [], pending: [] };
    try {
      const result = await TasksAPI.labelSuggestion(conversationId.value);
      const { data } = result;
      const matched = cleanLabels(data.message || '');
      const pending = Array.isArray(data.pending) ? data.pending : [];
      return { matched, pending };
    } catch {
      return { matched: [], pending: [] };
    }
  };

  onMounted(() => {
    fetchAiRoutingConfig();
  });

  return {
    captainTasksEnabled,
    isLabelSuggestionFeatureEnabled,
    getLabelSuggestions,
  };
}
